var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1208_43814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.4375C9.77813 14.4375 9.1875 15.0281 9.1875 15.75C9.1875 16.4719 9.77813 17.0625 10.5 17.0625C11.2219 17.0625 11.8125 16.4719 11.8125 15.75C11.8125 15.0281 11.2219 14.4375 10.5 14.4375ZM10.5 11.8125C11.2219 11.8125 11.8125 11.2219 11.8125 10.5C11.8125 9.77812 11.2219 9.1875 10.5 9.1875C9.77813 9.1875 9.1875 9.77812 9.1875 10.5C9.1875 11.2219 9.77813 11.8125 10.5 11.8125ZM10.5 6.5625C11.2219 6.5625 11.8125 5.97188 11.8125 5.25C11.8125 4.52812 11.2219 3.9375 10.5 3.9375C9.77813 3.9375 9.1875 4.52812 9.1875 5.25C9.1875 5.97187 9.77813 6.5625 10.5 6.5625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1208_43814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(21 21) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.903ff304b434b3dd62ba14c5dddbfae9.svg";
export { ForwardRef as ReactComponent };